export const html = {
  __html: `<style>
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: white !important
}

.root-cloudpay{
  background-color: white !important;
}

.AppHeader-container{
  display: none !important;
  margin-bottom: 2% !important;
}

.bodyInvoice {
  background-color: #f2f2f2 !important;
  margin: 48px auto;
  font-family: 'Roboto', sans-serif;
  text-align: center;
  color: black;
}
.mailContent {
  width: 700px !important;
  margin: 0 auto !important;
  background: #ffffff;
}
.imageHeader {
  width: 100%;
  padding: 48px 0 24px;
}
.imageHeader img {
  max-height: 60px;
}
.msgContainer {
  padding: 0 10% !important;
  text-align: center;
}
.tableHeaders {
  color: #6a7d88;
  border-bottom: 1px solid #ccc;
}
.ctaButtons {
  margin: 16px;
}
.leftContent {
  width: 75%;
}
.rightContent {
  width: 25%;
}
.planLabel {
  padding: 8px 0;
  font-weight: bold;
  color: {{planLabel}};
}
.amountLabel {
  color: {{amountLabel}};
  font-weight: bold;
  padding: 12px 0;
  text-align: right;
}
.cardInfo {
  font-size: 11px;
  color: #777777;
}
.moreInfo {
  padding: 48px 0;
  font-size: 13px;
}

@media print{
  .mailContent {
      border: 1px solid #ccc;
  }
  .tableHeaders{
      color: #ccc;
      border-bottom: 1px solid #ccc;
  }
  .planLabel{
      padding: 8px 0;
      font-weight: bold;
      color: {{planLabel}};
  }
  .amountLabel{
      color: {{amountLabel}};
      font-weight: bold;
      padding: 12px 0;
      text-align: right;
  }
  .cardInfo{
      font-size: 11px;
      color:#ccc;
  }
}

</style>
<div class="mailContent">
<div class="imageHeader">
    <img src={{clientLogo}} alt={{client}} />
</div>
<div class="msgContainer">
    <h2 style="color: {{orderLabel}}; text-align: center; font-size: 20px;margin-top: 20px;">{{accountNumber}}</h2>
    <p style="color:#909090; font-size: 15px; text-align: center; ">
        {{subtitle}}
    </p>
    <div style="padding: 24px 0 0;">
        <div style="padding: 16px; background-color:#f4f4f4;">
            <table width="100%" style="font-size: 12px; text-align: left;" cell-spacing="0" cell-padding="0">
                <thead>
                    <tr class="tableHeaders">
                        <th class="leftContent" style="border-bottom: 1px solid #ccc; padding-bottom: 8px;">SUBSCRIPTION
                        </th>
                        <th class="rightContent"
                            style="text-align: right; border-bottom: 1px solid #ccc; padding-bottom: 8px;">
                            PRICE</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="leftContent planLabel" style="border-top: 1px solid #ccc; padding-top: 8px;">{{planName}}</td>
                        <td class="rightContent amountLabel"style="border-top: 1px solid #ccc; padding-top: 8px; text-align: right;">{{amount}} {{currency}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="cardInfo">
                        <td class="leftContent" style="border-top: 1px solid #ccc; padding-top: 8px;">{{entityTitle}}</td>
                        <td class="rightContent" style="text-align: right; border-top: 1px solid #ccc; padding-top: 8px;">{{entity}}</td>
                    </tr>
                    ${(`{{reference}}` !== 'null') ? `
                      <tr class="cardInfo">
                        <td class="leftContent" style="border-top: 1px solid #ccc; padding-top: 8px;">{{referenceTitle}}</td>
                        <td class="rightContent" style="text-align: right; border-top: 1px solid #ccc; padding-top: 8px;">{{reference}}</td>
                      </tr>
                    ` : ''}
                    ${(`{{beneficiary}}` !== 'null') && `
                      <tr class="cardInfo">
                        <td class="leftContent" style="border-top: 1px solid #ccc; padding-top: 8px;">{{beneficiaryTitle}}</td>
                        <td class="rightContent" style="text-align: right; border-top: 1px solid #ccc; padding-top: 8px;">{{beneficiary}}</td>
                    </tr>
                    `}
                    ${(`{{accountNumber}}` !== 'null') && `
                      <tr class="cardInfo">
                        <td class="leftContent" style="border-top: 1px solid #ccc; padding-top: 8px;">{{accountTitle}}</td>
                        <td class="rightContent" style="text-align: right; border-top: 1px solid #ccc; padding-top: 8px;">{{accountNumber}}</td>
                      </tr>
                    `}


                </tfoot>
            </table>
        </div>
    </div>
    <p class="moreInfo">
        <span style="color:#909090;">For more information write to </span>
        <a href="mailto:{{mailContact}}" style="color: {{emailLabel}}; text-decoration: none;">{{mailContact}}</a>
    </p>
</div>
</div>`,
};
